import { render } from "./HopDongTable.vue?vue&type=template&id=d70d9a7e&ts=true"
import script from "./HopDongTable.vue?vue&type=script&lang=ts"
export * from "./HopDongTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__